<template>
  <v-card class="pa-4">
    <h3 class="text-center">Migrações</h3>
    <v-data-table
      :headers="headers"
      :items="migrations"
      class="main-table"
      hide-default-footer
      :items-per-page="migrations.length"
      :loading="loading"
      :header-props="headerProps"
    >
      <template #[`item.date`]="{ item }">
        {{ formatDateTime(item.date) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'
import utils from '../../../../Utils/FormatDate'

export default {
  name: 'PatternDetail',

  props: {
    patternId: Number,
  },

  data() {
    return {
      apiService: new ApiService(),
      migrations: [],
      loading: false,
      headerProps: {
        sortByText: 'Ordenar por',
      },
      headers: [
        { text: '', align: 'center', value: '', sortable: false },
        {
          text: 'Instituição origem',
          align: 'center',
          value: 'lastInstitution.name',
          sortable: false,
        },
        {
          text: 'Instituição destino',
          align: 'center',
          value: 'institution.name',
          sortable: false,
        },
        {
          text: 'Data',
          align: 'center',
          value: 'date',
          sortable: false,
        },
      ],
    }
  },

  created() {
    this.getMigrations()
  },

  methods: {
    formatDateTime(date) {
      return utils.dateTime(date)
    },

    getMigrations() {
      if (this.patternId) {
        this.apiService
          .get('electricalSafetyPattern/migrations/' + this.patternId)
          .then((response) => {
            this.migrations = response.content
            console.log(response)
          })
      }
    },
  },
}
</script>

<style></style>
